export default Object.freeze({
  GROUP: 'group', // customer of type group
  NONGROUP: 'nongroup', // customer of type individual + corporate
})